import { Component } from '@angular/core';

@Component({
	selector: 'svg-sprite',
	template: require('./svg-sprite.component.html')
})

export class SvgSpriteComponent {}
